import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { Form } from 'doNotSellInformation/components/form';
import { Modal } from 'doNotSellInformation/components/modal';
export const DoNotSell = () => {
    const initialState = {
        form_version: 'v1.0',
        cookie_consent: false,
        non_cookie_consent: false,
        first_name: '',
        last_name: '',
        email: '',
        it_is_my_data: undefined,
        i_am_authorized_by_owner: undefined,
        requires_authorization: false,
    };
    const [data, setData] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [showModal, setShowModal] = useState(false);
    const handleChange = (field) => (value) => {
        setData(Object.assign(Object.assign({}, data), { [field]: value }));
    };
    const handleOwnershipChange = (value) => {
        setData(Object.assign(Object.assign(Object.assign({}, data), { it_is_my_data: value, requires_authorization: !value }), (value ? undefined : { i_am_authorized_by_owner: false })));
    };
    const handleFormReset = () => {
        setData(initialState);
        setErrors({});
    };
    const emptyStringValidator = (value) => value !== undefined && value.trim() !== '';
    const maxLengthValidator = (value) => value.length <= 255;
    const validators = {
        first_name: [
            {
                validate: emptyStringValidator,
                message: 'You must provide a name.',
            },
            {
                validate: maxLengthValidator,
                message: 'Please do not go over 255 characters',
            },
        ],
        last_name: [
            {
                validate: emptyStringValidator,
                message: 'You must provide a last name.',
            },
            {
                validate: maxLengthValidator,
                message: 'Please do not go over 255 characters',
            },
        ],
        email: [
            {
                validate: value => emptyStringValidator(value) &&
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
                message: 'You must provide a valid email.',
            },
            {
                validate: maxLengthValidator,
                message: 'Please do not go over 255 characters',
            },
        ],
    };
    const validate = () => {
        let valid = true;
        const errors = {};
        if (data.first_name.length > 0 ||
            data.last_name.length > 0 ||
            data.email.length > 0 ||
            data.it_is_my_data !== undefined) {
            Object.keys(validators).forEach(k => {
                validators[k].forEach(v => {
                    if (!v.validate(data[k])) {
                        valid = false;
                        errors[k] = v.message;
                    }
                });
            });
            if (data.it_is_my_data !== true &&
                data.i_am_authorized_by_owner !== true) {
                valid = false;
                errors['authorization'] =
                    'You must either state that this data belongs to you or that you have consent from the owner.';
            }
        }
        else {
            if (!data.cookie_consent) {
                valid = false;
                errors['cookie_consent'] =
                    'You must either click this checkbox or fill the other fields.';
            }
        }
        setErrors(errors);
        return valid;
    };
    const submit = () => {
        var _a, _b;
        const valid = validate();
        if (valid) {
            if (data.cookie_consent) {
                Cookies.set('do_not_sell_information', 'true', { expires: 365 });
            }
            if (data.first_name) {
                data.first_name = (_a = data.first_name) === null || _a === void 0 ? void 0 : _a.trim();
                data.last_name = (_b = data.last_name) === null || _b === void 0 ? void 0 : _b.trim();
                data.non_cookie_consent = true;
                fetch(globalThis.vitalLibrary.getMainBackendUrl() + '/doNotSell', {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    method: 'post',
                    body: JSON.stringify(data),
                });
            }
            setShowModal(true);
        }
    };
    const handlers = {
        cookie_consent: handleChange('cookie_consent'),
        first_name: handleChange('first_name'),
        last_name: handleChange('last_name'),
        email: handleChange('email'),
        it_is_my_data: handleOwnershipChange,
        i_am_authorized_by_owner: handleChange('i_am_authorized_by_owner'),
        submit,
        formReset: handleFormReset,
    };
    return (React.createElement("div", null,
        React.createElement(Form, { data: data, handlers: handlers, errors: errors }),
        showModal && React.createElement(Modal, null)));
};
